
import { defineComponent, type PropType } from 'vue'

import IssueDetailMixin from '~/mixins/issueDetailMixin'

import { UiIssueLevel } from '~/utils/issue'

export default defineComponent({
  name: 'IgnoreIssueAllFiles',
  mixins: [IssueDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      required: false
    },
    shortcode: {
      type: String,
      required: false
    },
    issueLevel: {
      type: String as PropType<UiIssueLevel>,
      default: UiIssueLevel.Repository
    },
    repositoryId: {
      type: String,
      default: ''
    },
    prLabel: {
      type: String,
      default: 'pull request'
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    UiIssueLevel() {
      return UiIssueLevel
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {} as {
        repositoryId?: string
        checkId?: string
        issueShortcode?: string
        alsoCreateRule?: boolean
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
        if (this.issueLevel === UiIssueLevel.Repository) {
          params.alsoCreateRule = true
        }
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueRepository(params)
        this.$toast.success(`${this.issueShortcode} ignored for all files in this repository.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        this.$logErrorAndToast(
          e as Error,
          'Something went wrong while ignoring this issue, please contact support.',
          undefined,
          {
            context: 'Ignore Issue',
            params: {
              method: 'Ignore Issue All Files',
              ...params
            }
          }
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
